/* eslint-disable react-hooks/exhaustive-deps */
import { Check, ChevronsUpDown, LoaderCircle, XIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { useEffect, useMemo, useState } from "react";
import { GenericType } from "@/types";
import { useErpMapping } from "./use-erp-mapping";

export const ErpMappingComponent = ({
  placeholder,
  value,
  onChange,
  defaultValue,
  bindValue,
  bindLabel,
  className,
  onBlur,
  parentOrderType,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  const { list, loading, onErpSearch } = useErpMapping();

  useEffect(() => {
    setTimeout(() => {
      if (defaultValue) {
        onChange(defaultValue);
      }
    }, 100);
  }, [defaultValue]);

  useEffect(() => {
    if (open) {
      onErpSearch({ text: "", order_type: parentOrderType });
    }
  }, [open]);

  const displayValue = useMemo(() => {
    if (value === "") {
      return <span className="text-slate-400">Select Erp</span>;
    }
    return value;
  }, [value]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="flex items-center gap-2 !mt-[-1px] ">
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className={cn("w-full justify-between capitalize", className)}
          >
            <span className="truncate">
              {displayValue || (
                <span className="opacity-65">{placeholder}</span>
              )}
            </span>
            {loading ? (
              <LoaderCircle className="ml-2 h-4 w-4 shrink-0 opacity-50 animate-spin" />
            ) : (
              <ChevronsUpDown className="ml-2 translate-x-3 h-4 w-4 shrink-0 opacity-50" />
            )}
          </Button>
        </PopoverTrigger>
        {value ? (
          <Button
            onClick={() => {
              onChange("");
            }}
            className=" absolute right-6 p-0"
            variant={"ghost"}
          >
            <XIcon />
          </Button>
        ) : null}
      </div>

      <PopoverContent
        className="w-full p-0  z-[999999]"
        align="start"
        onBlur={onBlur}
      >
        <Command className={cn(loading ? "hidden" : "")}>
          <CommandInput placeholder="Search..." className="h-9" />
          <CommandList>
            <CommandEmpty>No Item found.</CommandEmpty>
            <CommandGroup>
              {list?.map((option: GenericType) => (
                <CommandItem
                  key={option?.[bindValue]}
                  value={option?.[bindLabel]}
                  onSelect={() => {
                    onChange(option?.[bindValue]);
                    setOpen(false);
                  }}
                >
                  {option?.[bindLabel]}
                  <Check
                    className={cn(
                      "ml-auto",
                      value?.toLowerCase() ===
                        option?.[bindValue]?.toLowerCase()
                        ? "opacity-100"
                        : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
